import { render, staticRenderFns } from "./CustomerRegListItem.vue?vue&type=template&id=a0adb5b2&scoped=true&"
import script from "./CustomerRegListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerRegListItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRegListItem.vue?vue&type=style&index=0&id=a0adb5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0adb5b2",
  null
  
)

export default component.exports